import { call, put, takeLatest } from "redux-saga/effects";
import { API } from "../../../api/api";
import { gamesAPI } from "../api/api";
import { GamesActionTypes } from "../actions/actionTypes";
import { ToasterService } from "../../../services/toaster/toaster.service";

function* editGame(action) {
    try {
        const { game, refreshData } = action.payload;

        yield call(() => gamesAPI.editGame(game));
        ToasterService.successToast("Game successfully edited");

        yield put({
            type: GamesActionTypes.EDIT_GAME_SUCCESS
        });

        yield put({
            type: GamesActionTypes.GET_GAMES,
            payload: refreshData
        });
    } catch (e) {
        API.handleError(e.response, "Error saving Game.");

        yield put({
            type: GamesActionTypes.EDIT_GAME_FAIL,
            message: e.message
        });
    }
}

export function* editGameWatcher() {
    yield takeLatest(GamesActionTypes.EDIT_GAME, editGame);
}

function* createGame(action) {
    try {
        const { game, refreshData } = action.payload;

        yield call(() => gamesAPI.createGame(game));
        ToasterService.successToast("Game successfully created");

        yield put({
            type: GamesActionTypes.CREATE_GAME_SUCCESS
        });

        yield put({
            type: GamesActionTypes.GET_GAMES,
            payload: refreshData
        });
    } catch (e) {
        API.handleError(e.response, "Error saving Game.");

        yield put({
            type: GamesActionTypes.CREATE_GAME_FAIL,
            message: e.message
        });
    }
}

export function* createGameWatcher() {
    yield takeLatest(GamesActionTypes.CREATE_GAME, createGame);
}
